import React from 'react'
import { ExclamationTriangleFill } from 'react-bootstrap-icons'
import Modal from '../../../../Modal/Modal'

export default function DeleteBudgetRowModal({ isOpen, onClose, onConfirm, influencerName, contentPieceCount }) {
  const hasContent = contentPieceCount > 0

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header>
        <h2 className="dark:text-white">Delete Row</h2>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col gap-3">
          <p className="text-sm font-semibold text-gray-700 dark:text-white">
            Delete <span className="text-rb-green">{influencerName}</span>?
          </p>
          {hasContent ? (
            <div className="flex items-start gap-2 rounded-lg bg-red-50 p-3 dark:bg-rb-dark-mode-lighter">
              <ExclamationTriangleFill className="mt-0.5 shrink-0 text-red-500" />
              <p className="text-sm text-gray-700 dark:text-gray-300">
                This row has {contentPieceCount} content piece{contentPieceCount === 1 ? '' : 's'}. Deleting it will
                permanently remove {contentPieceCount === 1 ? 'it' : 'them'} too.
              </p>
            </div>
          ) : (
            <p className="text-sm text-gray-500 dark:text-gray-400">This row is empty and can be safely deleted.</p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="w-full flex justify-between items-center">
          <Modal.DissmissButton className="rb-btn-cancel px-4 py-2 text-sm font-semibold rounded-lg">
            Cancel
          </Modal.DissmissButton>
          <button
            type="button"
            onClick={onConfirm}
            className="px-5 py-2.5 text-sm font-semibold text-white bg-red-500 hover:bg-red-600 rounded-lg transition-colors"
          >
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
